export const SIGNIN = '@@signin/REQUEST';
export const SIGNIN_WITH_LINKEDIN = '@@signin/SIGNIN_WITH_LINKEDIN';
export const SIGNIN_SUCCESS = '@@signin/SUCCESS';
export const SIGNIN_ABORT = '@@signin/ABORT';

/**
 * Action that represents a vanilla sign in with user + pw
 * @param {Object} param
 * @param {String} param.email
 * @param {String} param.password
 * @param {String} param.code
 * @param {String} param.flow
 * @param {String} param.identity_id
 * @param {String} param.flavor
 * @param {String} param.context
 * @param {Function} resolve
 * @param {Function} reject
 */
export const signin = (
  {
    email,
    password,
    code,
    identity_id,
    flavor,
    context,
  },
  resolve,
  reject,
) => ({
  type: SIGNIN,
  email: email.toLowerCase(),
  password,
  code,
  identity_id,
  flavor,
  context,
  resolve,
  reject,
});

/**
 * Request signin with linkedin oauth code
 * @param {Object} params
 * @param {String} params.code - Linkedin Oauth code
 * @param {String} [params.context] - context of the sign-in
 */
export const signinWithLinkedin = (
  {
    context,
    code,
  },
  resolve,
  reject,
) => ({
  type: SIGNIN_WITH_LINKEDIN,
  context,
  code,
  resolve,
  reject,
});

/**
 *
 * @param {Object} params
 * @param {String} params.flow //different from signup flow
 * @param {String} params.flavor
 * @param {String} params.context
 */
export const signinSuccess = ({
  flow,
  flavor,
  context,
}) => ({
  type: SIGNIN_SUCCESS,
  context,
  flow,
  flavor,
});

/**
 *
 * @param {*} context
 */
export const signinAbort = (context) => ({
  type: SIGNIN_ABORT,
  context,
});
